export default "__VITE_ASSET__CqaM8kXN__"